import { getResolvedAuthProvider } from './authFeature'

export const getWebSocketUrl = () => {
  // to be provided by host application using env setup
  return (
    window._env_.VITE_WEBSOCKET_URLS || import.meta.env['VITE_WEBSOCKET_URLS']
  )
}

export const getAuthProviderType = () => {
  // Prefer the provider resolved from GET /auth/feature; fall back to the env var
  // (used before the feature call resolves, or if it failed).
  return (
    getResolvedAuthProvider() ??
    (window._env_.VITE_AUTH_PROVIDER || import.meta.env['VITE_AUTH_PROVIDER'])
  )
}

export const getBaseUrl = () => {
  // to be provided by host application using env setup
  return window._env_.VITE_API_URL || import.meta.env['VITE_API_URL']
}

export const getEnvName = () => {
  return window._env_.VITE_ENVIRONMENT || import.meta.env['VITE_ENVIRONMENT']
}

export const getEnableCall = () => {
  const enableCall =
    window._env_.VITE_ENABLE_AWS_CONNECT ||
    import.meta.env['VITE_ENABLE_AWS_CONNECT']
  if (enableCall === 'true') return true
  else return true
}
export const AUTH_PROVIDER = {
  COGNITO: 'COGNITO',
  MSAL: 'MSAL',
  MS_BACKEND: 'MS_BACKEND',
}

// API Endpoints
export const API_URL = '/api/'
export const ENTITY_MANAGER_BASE = 'entity-management'
export const CORE_BASE = 'core'
export const TEMPLATE_BASE = 'template'
export const AUDIT_HISTORY_BASE = 'audit-history'
export const DELIVERY_BASE = 'delivery'
export const WORKFLOW_BASE = 'workflow/v1'
export const WORKFLOW = 'workflow'
export const WORKFLOW_BASE_V2 = 'workflow/v2'
export const CONSENT_BASE = 'consent-request/public/v1'
export const CONSENT_BASE_V2 = 'consent-request/public/v2'
export const AWS_BASE = 'aws-connect/cti/caller'
export const CONSENT_REQUEST_BASE = 'consent-request'
export const HCP_BASE = 'hcp'
export const DUPLICATE = 'entity-management/v2/de-duplication/find-duplicates/'
export const USER_PREFERENCES_BASE = 'user-preferences'
export const INTEGRATIONS_BASE = 'integrations'
export const CASE_AUTOMATION = 'case-automation/'

export const API_BASE_URL = `${getBaseUrl()}${API_URL}`
export const WEBSOCKET_URL = getWebSocketUrl()

export const API_END_POINT = {
  ENTITY_MANAGER: `${API_BASE_URL}${ENTITY_MANAGER_BASE}/v1/`,
  ENTITY_MANAGER_V3: `${API_BASE_URL}${ENTITY_MANAGER_BASE}/v3/`,
  LAYOUT_MANAGER: `${API_BASE_URL}${ENTITY_MANAGER_BASE}/v3/`,
  CORE: `${API_BASE_URL}${CORE_BASE}/`,
  V2_CORE: `${API_BASE_URL}${CORE_BASE}/v2/`,
  V1_CORE: `${API_BASE_URL}${CORE_BASE}/v1/`,
  CLIENT_CONFIG: `${API_BASE_URL}${CORE_BASE}`,
  TEMPLATE: `${API_BASE_URL}${TEMPLATE_BASE}`,
  V0_ENTITY_MANAGER: `${API_BASE_URL}${ENTITY_MANAGER_BASE}`,
  V2_ENTITY_MANAGER: `${API_BASE_URL}${ENTITY_MANAGER_BASE}/v3/`,
  V3_ENTITY_MANAGER: `${API_BASE_URL}${ENTITY_MANAGER_BASE}/v3/`,
  AUDIT_HISTORY: `${API_BASE_URL}${AUDIT_HISTORY_BASE}/`,
  DELIVERY: `${API_BASE_URL}${DELIVERY_BASE}`,
  WORKFLOW: `${API_BASE_URL}${WORKFLOW_BASE}`,
  WORKFLOW_HCP: `${API_BASE_URL}${HCP_BASE}`,
  V2_WORKFLOW: `${API_BASE_URL}${WORKFLOW_BASE_V2}`,
  CONSENT: `${API_BASE_URL}${CONSENT_BASE}`,
  CONSENT_V2: `${API_BASE_URL}${CONSENT_BASE_V2}`,
  CTI: `${API_BASE_URL}${CORE_BASE}/${AWS_BASE}`,
  CONSENT_REQUEST: `${API_BASE_URL}${CONSENT_REQUEST_BASE}/`,
  HCP: `${API_BASE_URL}${HCP_BASE}/`,
  DUPLICATION: `${API_BASE_URL}${DUPLICATE}`,
  USER_PREFERENCES: `${API_BASE_URL}${CORE_BASE}/${USER_PREFERENCES_BASE}`,
  INTEGRATIONS: `${API_BASE_URL}${INTEGRATIONS_BASE}/`,
  V1_INTEGRATIONS: `${API_BASE_URL}${INTEGRATIONS_BASE}/v1/`,
  CASE_AUTOMATION: `${API_BASE_URL}${CASE_AUTOMATION}`,
  ENTITY_MANAGER_V2: `${API_BASE_URL}${ENTITY_MANAGER_BASE}/v2/`,
}

// Entity Manager Endpoints
export const ENTITY_MANAGER_END_POINTS = {
  BASE: 'base/entities',
  CATEGORY_VALUE: 'category-value',
  ENTITIES: 'entities',
  ENTITY_DATA: 'entity-data',
  ENTITY_FIELDS: 'entities/fields',
  ENTITY_RELATIONSHIP: 'entities/relation',
  LAYOUT: 'layout',
  VALIDATION: 'validation',
  PROCESS: 'process',
  CASE_MANAGEMENT: 'case-management',
  TASKS: 'tasks',
  PROVIDER_TYPE: 'c_providers',
}

// SLA Management Endpoints
export const SLA_MANAGEMENT_END_POINTS = {
  LIST: 'sla',
}
